import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ServicehotelService } from 'src/app/api/config/servicehotel.service';
import { GlobalService } from 'src/app/api/global.service';
import { LoadingModalComponent } from 'src/app/components/loading-modal/loading-modal.component';
import { SearchComponent } from 'src/app/components/search/search.component';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import SwalAlert from 'src/app/utils/swalalert';
import AlertifyHelper from 'src/app/utils/utils';
declare var $: any;

@Component({
  selector: 'app-servicehotel-list',
  templateUrl: './servicehotel-list.component.html',
  styleUrls: ['./servicehotel-list.component.css']
})
export class ServicehotelListComponent {
  @ViewChild(LoadingModalComponent) LoadingModalComponent: any;
  @Output() onSubmitEvent = new EventEmitter<string>();

  branchofficeSlug = '';
  items: any = [];
  params: any = {
    search: ''
  };
  page = 1;
  count = 0;

  @ViewChild(SearchComponent) searchComponent: any;

  dataPagination: any = {
    pageSize: 0,
    currentPage: this.page,
    totalItems: 0
  };

  constructor(
    private routeActivated: ActivatedRoute,
    private navigationTrackerService: NavigationTrackerService,
    private serviceHotelService: ServicehotelService,
    private router: Router,
    private globalService: GlobalService,
    private alert: SwalAlert,
    private alertifyMsg: AlertifyHelper
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
  }

  list() {
    let val_params = 'search=' + this.params.search + '&page=' + this.page;
    this.LoadingModalComponent.show();
    this.serviceHotelService.list(val_params).subscribe({
      next: (data: any) => {
        this.items = data.results;
        this.dataPagination.pageSize = data.paginate_by;
        this.dataPagination.currentPage = this.page;
        this.dataPagination.totalItems = data.total;
        this.LoadingModalComponent.hide();
      }
    });
  }

  search(text: any) {
    this.params.search = text;
    this.page = 1;
    this.list();
  }

  handlePageChange(event: any): void {
    this.page = event;
    this.list();
  }

  refresh() {
    this.page = 1;
    this.params.search = '';
    this.searchComponent.textSearch = '';
    this.list();
  }

  edit(id: number) {
    this.router.navigate([
      this.branchofficeSlug + '/catalogo/marcas/editar',
      id
    ]);
  }

  delete(item: any, _index: any) {
    let options = {
      title: '¿Estás segur@?',
      message: item.description,
      cancel: 'Cancelar',
      confirm: 'Eliminar'
    };
    this.alert.confirmDelete(options).then((result: any) => {
      if (result.isConfirmed) {
        this.LoadingModalComponent.show();
        this.serviceHotelService.delete(item.id).subscribe({
          next: (data: any) => {
            this.items.splice(_index, 1);
            this.alertifyMsg.success(
              'El registro ' + item.description + ' se ha eliminado con éxito'
            );
            this.list();
          }
        });
      }
    });
  }

  close() {
    this.onSubmitEvent.emit();
    this.LoadingModalComponent.hide();
    (<any>$('#openExtendsServiceHotelList')).modal('hide');
  }
}
